const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
const prefersReducedMotion = reducedMotionQuery.matches;
document.documentElement.classList.add("has-motion");

const header = document.querySelector("[data-header]");
const scrollProgress = document.querySelector("[data-scroll-progress]");
const hero = document.querySelector(".hero");
const pageIntro = document.querySelector("[data-page-intro]");
const menuToggle = document.querySelector(".menu-toggle");
const mobileNav = document.querySelector(".mobile-nav");
const tabButtons = document.querySelectorAll(".tab-button");
const tabPanels = document.querySelectorAll(".tab-panel");
const registrationForm = document.querySelector("#RegistrationForm");
const tryoutSuccess = registrationForm?.querySelector("[data-tryout-success]");
const tryoutRetry = registrationForm?.querySelector("[data-tryout-retry]");
const tryoutCheckoutKey = "tnvultures-tryout-checkout";

if (registrationForm) {
  const variantIds = Object.fromEntries(
    Array.from(document.querySelectorAll("[data-tryout-variants] [data-age-group]"), (item) => [
      item.dataset.ageGroup,
      Number(item.dataset.variantId),
    ])
  );

  registrationForm.addEventListener("submit", (event) => {
    const ageGroup = registrationForm.querySelector('[name="contact[Age group]"]')?.value;
    const variantId = variantIds[ageGroup];
    if (!variantId) {
      event.preventDefault();
      window.alert("The $30 tryout checkout is unavailable. Please contact the team before submitting.");
      return;
    }

    const registrationId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    registrationForm.querySelector("[data-tryout-registration-id]").value = registrationId;
    try {
      sessionStorage.setItem(tryoutCheckoutKey, JSON.stringify({
        variantId,
        registrationId,
        createdAt: Date.now(),
      }));
    } catch (error) {
      event.preventDefault();
      window.alert("Checkout could not be prepared in this browser. Please enable site storage and try again.");
    }
  });

  if (tryoutSuccess) {
    const checkout = async () => {
      let pending;
      try {
        pending = JSON.parse(sessionStorage.getItem(tryoutCheckoutKey) || "null");
      } catch (error) {
        pending = null;
      }
      if (!pending || !Object.values(variantIds).includes(pending.variantId) ||
          Date.now() - pending.createdAt > 30 * 60 * 1000) {
        tryoutSuccess.textContent = "Your details were received, but checkout could not be started automatically. Please contact the team to complete payment.";
        return;
      }

      tryoutRetry.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || "/";
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{
            id: pending.variantId,
            quantity: 1,
            properties: { "Registration ID": pending.registrationId },
          }] }),
        });
        if (!response.ok) throw new Error("Could not add tryout fee to cart");
        sessionStorage.removeItem(tryoutCheckoutKey);
        window.location.assign(`${root}checkout`);
      } catch (error) {
        tryoutSuccess.textContent = "Your details were received, but checkout did not open. Please use the button below to retry payment.";
        tryoutRetry.hidden = false;
      }
    };

    tryoutRetry.addEventListener("click", checkout);
    checkout();
  }
}
const mediaButtons = document.querySelectorAll("[data-media-button]");
const mediaCarousels = document.querySelectorAll("[data-media-carousel]");
const lightbox = document.querySelector("[data-lightbox]");
const closeLightbox = document.querySelector("[data-close-lightbox]");
const lightboxSlides = lightbox ? Array.from(lightbox.querySelectorAll("[data-lightbox-slide]")) : [];
const lightboxThumbnails = lightbox ? Array.from(lightbox.querySelectorAll("[data-lightbox-thumbnail]")) : [];
const lightboxCurrent = lightbox ? lightbox.querySelector("[data-lightbox-current]") : null;
let activeGalleryIndex = 0;
let lastGalleryTrigger = null;
let scrollFrameRequested = false;

function updatePageMotion() {
  if (header) {
    header.classList.toggle("is-scrolled", window.scrollY > 16);
  }

  if (scrollProgress) {
    const scrollableHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    const progress = Math.min(Math.max(window.scrollY / scrollableHeight, 0), 1);
    scrollProgress.style.transform = `scaleX(${progress})`;
  }

  if (hero && !prefersReducedMotion) {
    const heroTravel = Math.min(window.scrollY, window.innerHeight * 1.1);
    hero.style.setProperty("--hero-shift", `${heroTravel * 0.12}px`);
    hero.style.setProperty("--hero-content-shift", `${heroTravel * -0.045}px`);
  }
}

function requestPageMotionUpdate() {
  if (scrollFrameRequested) return;
  scrollFrameRequested = true;
  window.requestAnimationFrame(() => {
    updatePageMotion();
    scrollFrameRequested = false;
  });
}

window.addEventListener("scroll", requestPageMotionUpdate, { passive: true });
window.addEventListener("resize", requestPageMotionUpdate, { passive: true });
updatePageMotion();

window.requestAnimationFrame(() => document.documentElement.classList.add("motion-ready"));

if (pageIntro) {
  if (prefersReducedMotion) {
    pageIntro.remove();
  } else {
    window.setTimeout(() => pageIntro.classList.add("is-complete"), 1120);
    window.setTimeout(() => pageIntro.remove(), 1700);
  }
}

if (menuToggle && mobileNav) {
  menuToggle.addEventListener("click", () => {
    const isOpen = mobileNav.classList.toggle("is-open");
    menuToggle.setAttribute("aria-expanded", String(isOpen));
    menuToggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
  });

  mobileNav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      mobileNav.classList.remove("is-open");
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.setAttribute("aria-label", "Open menu");
    });
  });
}

tabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const tab = button.dataset.tab;

    tabButtons.forEach((item) => {
      const isActive = item === button;
      item.classList.toggle("is-active", isActive);
      item.setAttribute("aria-selected", String(isActive));
      item.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    tabPanels.forEach((panel) => {
      const isActive = panel.dataset.panel === tab;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  });

  button.addEventListener("keydown", (event) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const buttons = Array.from(tabButtons);
    const currentIndex = buttons.indexOf(button);
    const nextIndex = event.key === "Home" ? 0 : event.key === "End" ? buttons.length - 1 :
      (currentIndex + (event.key === "ArrowRight" ? 1 : -1) + buttons.length) % buttons.length;
    buttons[nextIndex].focus();
    buttons[nextIndex].click();
  });
});

function normalizeGalleryIndex(index, total) {
  return (index + total) % total;
}

function setCarouselSlide(carousel, index) {
  const slides = Array.from(carousel.querySelectorAll("[data-carousel-slide]"));
  if (!slides.length) return;

  const nextIndex = normalizeGalleryIndex(index, slides.length);
  const dots = Array.from(carousel.querySelectorAll("[data-carousel-dot]"));
  const current = carousel.querySelector("[data-carousel-current]");

  slides.forEach((slide, slideIndex) => {
    const isActive = slideIndex === nextIndex;
    slide.classList.toggle("is-active", isActive);
    slide.setAttribute("tabindex", isActive ? "0" : "-1");
    if (isActive) {
      slide.removeAttribute("aria-hidden");
    } else {
      slide.setAttribute("aria-hidden", "true");
    }
  });

  dots.forEach((dot, dotIndex) => {
    const isActive = dotIndex === nextIndex;
    dot.classList.toggle("is-active", isActive);
    dot.setAttribute("aria-selected", String(isActive));
    dot.setAttribute("tabindex", isActive ? "0" : "-1");
  });

  if (current) current.textContent = String(nextIndex + 1).padStart(2, "0");
  carousel.dataset.activeIndex = String(nextIndex);
  activeGalleryIndex = nextIndex;
}

mediaCarousels.forEach((carousel) => {
  const previous = carousel.querySelector("[data-carousel-previous]");
  const next = carousel.querySelector("[data-carousel-next]");
  const dots = carousel.querySelectorAll("[data-carousel-dot]");
  const viewport = carousel.querySelector(".media-carousel-viewport");
  let touchStartX = null;

  previous?.addEventListener("click", () => {
    setCarouselSlide(carousel, Number(carousel.dataset.activeIndex || 0) - 1);
  });

  next?.addEventListener("click", () => {
    setCarouselSlide(carousel, Number(carousel.dataset.activeIndex || 0) + 1);
  });

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      setCarouselSlide(carousel, Number(dot.dataset.galleryIndex || 0));
    });
  });

  viewport?.addEventListener("touchstart", (event) => {
    stopAutoplay();
    touchStartX = event.changedTouches[0]?.clientX ?? null;
  }, { passive: true });

  viewport?.addEventListener("touchend", (event) => {
    if (touchStartX === null) return;
    const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
    touchStartX = null;
    if (Math.abs(distance) < 45) return;
    const direction = distance < 0 ? 1 : -1;
    setCarouselSlide(carousel, Number(carousel.dataset.activeIndex || 0) + direction);
    startAutoplay();
  }, { passive: true });

  let autoplayTimer = null;

  function stopAutoplay() {
    if (autoplayTimer) window.clearInterval(autoplayTimer);
    autoplayTimer = null;
  }

  function startAutoplay() {
    stopAutoplay();
    if (prefersReducedMotion || document.hidden) return;
    autoplayTimer = window.setInterval(() => {
      setCarouselSlide(carousel, Number(carousel.dataset.activeIndex || 0) + 1);
    }, 6500);
  }

  carousel.addEventListener("pointerenter", stopAutoplay);
  carousel.addEventListener("pointerleave", startAutoplay);
  carousel.addEventListener("focusin", stopAutoplay);
  carousel.addEventListener("focusout", (event) => {
    if (!carousel.contains(event.relatedTarget)) startAutoplay();
  });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stopAutoplay();
    else startAutoplay();
  });

  setCarouselSlide(carousel, 0);
  startAutoplay();
});

document.querySelectorAll("[data-uniform-gallery]").forEach((gallery) => {
  const images = Array.from(gallery.querySelectorAll("[data-uniform-image]"));
  const current = gallery.querySelector("[data-uniform-current]");
  const previous = gallery.querySelector("[data-uniform-previous]");
  const next = gallery.querySelector("[data-uniform-next]");
  let activeIndex = 0;

  function showUniformImage(index) {
    if (!images.length) return;
    activeIndex = normalizeGalleryIndex(index, images.length);
    images.forEach((image, imageIndex) => {
      const isActive = imageIndex === activeIndex;
      image.classList.toggle("is-active", isActive);
      if (isActive) image.removeAttribute("aria-hidden");
      else image.setAttribute("aria-hidden", "true");
    });
    if (current) current.textContent = String(activeIndex + 1).padStart(2, "0");
  }

  previous?.addEventListener("click", () => showUniformImage(activeIndex - 1));
  next?.addEventListener("click", () => showUniformImage(activeIndex + 1));
  showUniformImage(0);
});

function showLightboxSlide(index) {
  if (!lightboxSlides.length) return;
  const nextIndex = normalizeGalleryIndex(index, lightboxSlides.length);

  lightboxSlides.forEach((slide, slideIndex) => {
    const isActive = slideIndex === nextIndex;
    slide.classList.toggle("is-active", isActive);
    if (isActive) {
      slide.removeAttribute("aria-hidden");
    } else {
      slide.setAttribute("aria-hidden", "true");
    }
  });

  lightboxThumbnails.forEach((thumbnail, thumbnailIndex) => {
    const isActive = thumbnailIndex === nextIndex;
    thumbnail.classList.toggle("is-active", isActive);
    thumbnail.setAttribute("aria-current", String(isActive));
  });

  if (lightboxCurrent) lightboxCurrent.textContent = String(nextIndex + 1).padStart(2, "0");
  activeGalleryIndex = nextIndex;
  mediaCarousels.forEach((carousel) => setCarouselSlide(carousel, nextIndex));
}

function openLightbox(index = activeGalleryIndex) {
  if (!lightbox || !lightboxSlides.length) return;
  lastGalleryTrigger = document.activeElement;
  showLightboxSlide(index);
  lightbox.classList.add("is-open");
  lightbox.setAttribute("aria-hidden", "false");
  document.body.classList.add("no-scroll");
  if (closeLightbox) closeLightbox.focus();
}

function hideLightbox() {
  if (!lightbox || !lightbox.classList.contains("is-open")) return;
  lightbox.classList.remove("is-open");
  lightbox.setAttribute("aria-hidden", "true");
  document.body.classList.remove("no-scroll");
  if (lastGalleryTrigger instanceof HTMLElement) lastGalleryTrigger.focus();
}

mediaButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const requestedIndex = Number(button.dataset.galleryIndex);
    openLightbox(Number.isNaN(requestedIndex) ? activeGalleryIndex : requestedIndex);
  });
});

if (closeLightbox) {
  closeLightbox.addEventListener("click", hideLightbox);
}

if (lightbox) {
  const previous = lightbox.querySelector("[data-lightbox-previous]");
  const next = lightbox.querySelector("[data-lightbox-next]");
  const stage = lightbox.querySelector(".lightbox-stage");
  let touchStartX = null;

  previous?.addEventListener("click", () => showLightboxSlide(activeGalleryIndex - 1));
  next?.addEventListener("click", () => showLightboxSlide(activeGalleryIndex + 1));

  lightboxThumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => showLightboxSlide(Number(thumbnail.dataset.galleryIndex || 0)));
  });

  stage?.addEventListener("touchstart", (event) => {
    touchStartX = event.changedTouches[0]?.clientX ?? null;
  }, { passive: true });

  stage?.addEventListener("touchend", (event) => {
    if (touchStartX === null) return;
    const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
    touchStartX = null;
    if (Math.abs(distance) < 45) return;
    showLightboxSlide(activeGalleryIndex + (distance < 0 ? 1 : -1));
  }, { passive: true });

  lightbox.addEventListener("click", (event) => {
    if (event.target === lightbox) {
      hideLightbox();
    }
  });
}

document.querySelectorAll(".form-status").forEach((status) => status.focus());

window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    hideLightbox();
  }

  if (lightbox?.classList.contains("is-open") && event.key === "ArrowLeft") {
    showLightboxSlide(activeGalleryIndex - 1);
  }

  if (lightbox?.classList.contains("is-open") && event.key === "ArrowRight") {
    showLightboxSlide(activeGalleryIndex + 1);
  }
});

const revealGroups = [
  ".section-heading",
  ".wide-copy",
  ".event-card",
  ".stats-grid > div",
  ".program-statement",
  ".player-card",
  ".staff-card",
  ".values-grid article",
  ".registration-copy",
  ".registration-form",
  ".media-carousel",
  ".media-album-card",
  ".social-feed-card",
  ".product-card",
  ".uniforms-callout-content",
  ".uniforms-intro > *",
  ".uniform-product-info > *",
  ".uniforms-checkout-band > *",
  ".cart-item",
  ".cart-summary",
  ".current-sponsors",
  ".sponsor-levels article",
  ".sponsor-form",
  ".contact-section > *"
];

const revealItems = Array.from(document.querySelectorAll(revealGroups.join(",")));

revealItems.forEach((item, index) => {
  item.classList.add("motion-item");
  item.style.setProperty("--motion-delay", `${(index % 4) * 70}ms`);
});

if (prefersReducedMotion || !("IntersectionObserver" in window)) {
  revealItems.forEach((item) => item.classList.add("is-visible"));
} else {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

  revealItems.forEach((item) => revealObserver.observe(item));
}

const countUpItems = Array.from(document.querySelectorAll("[data-count-up]"));

function setCounterValue(counter, value) {
  const prefix = counter.dataset.countPrefix || "";
  const suffix = counter.dataset.countSuffix || "";
  counter.textContent = `${prefix}${value}${suffix}`;
}

function animateCounter(counter) {
  if (counter.dataset.counted === "true") return;
  counter.dataset.counted = "true";

  const target = Number(counter.dataset.countTarget || 0);
  const duration = Number(counter.dataset.countDuration || 1400);
  const delay = Number(counter.dataset.countDelay || 0);

  if (prefersReducedMotion || !Number.isFinite(target)) {
    setCounterValue(counter, target);
    return;
  }

  setCounterValue(counter, 0);
  counter.classList.add("is-counting");

  window.setTimeout(() => {
    const startedAt = performance.now();

    function updateCounter(now) {
      const progress = Math.min((now - startedAt) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      setCounterValue(counter, Math.round(target * easedProgress));

      if (progress < 1) {
        window.requestAnimationFrame(updateCounter);
      } else {
        setCounterValue(counter, target);
        counter.classList.remove("is-counting");
      }
    }

    window.requestAnimationFrame(updateCounter);
  }, delay);
}

if (prefersReducedMotion || !("IntersectionObserver" in window)) {
  countUpItems.forEach(animateCounter);
} else {
  countUpItems.forEach((counter) => setCounterValue(counter, 0));

  const countObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      animateCounter(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.55 });

  countUpItems.forEach((counter) => countObserver.observe(counter));
}

const sectionLinks = Array.from(document.querySelectorAll('.desktop-nav a[href^="#"], .mobile-nav a[href^="#"]'));
const trackedSections = Array.from(document.querySelectorAll("main section[id]")).filter((section) =>
  sectionLinks.some((link) => link.getAttribute("href") === `#${section.id}`)
);

if ("IntersectionObserver" in window) {
  const sectionObserver = new IntersectionObserver((entries) => {
    const activeEntry = entries.find((entry) => entry.isIntersecting);
    if (!activeEntry) return;
    const activeHash = `#${activeEntry.target.id}`;

    sectionLinks.forEach((link) => {
      const isActive = link.getAttribute("href") === activeHash;
      link.classList.toggle("is-active", isActive);
      if (isActive) link.setAttribute("aria-current", "location");
      else link.removeAttribute("aria-current");
    });
  }, { threshold: 0.01, rootMargin: "-30% 0px -60% 0px" });

  trackedSections.forEach((section) => sectionObserver.observe(section));
}

if (!prefersReducedMotion && window.matchMedia("(pointer: fine)").matches) {
  const motionCards = document.querySelectorAll(
    ".event-card, .player-card, .staff-card, .values-grid article, .product-card, .uniform-product-card, .sponsor-levels article, .social-feed-card, .media-album-card"
  );

  motionCards.forEach((card) => {
    card.classList.add("motion-card");
    card.addEventListener("pointermove", (event) => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty("--spot-x", `${((event.clientX - rect.left) / rect.width) * 100}%`);
      card.style.setProperty("--spot-y", `${((event.clientY - rect.top) / rect.height) * 100}%`);
    });
  });
}
